import Modal from '../Modal';
import styles from './ConfirmDeleteModal.module.scss';
import { ReactComponent as Bin } from '../../../assets/svg/icons/trash_red.svg';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import clx from 'classnames';

const BUTTON_VARIANTS = {
  default: 'return_button',
  dangerLight: 'danger_light_button',
  danger: 'confirm_button',
  primary: 'primary_button',
};

const ConfirmDeleteModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  content,
  action,
  buttons = [],
  width = '450px',
  buttonsActions = [() => setIsModalOpen(false)],
  buttonVariants = [],
  showChevron = false,
  centered = true,
  Icon = Bin,
}) => {
  const { t } = useTranslation();
  const btns = buttons.length ? buttons : [t('common.actions.cancel'), t('common.actions.disable')];
  const resolvedVariants = buttonVariants.length
    ? buttonVariants
    : btns.map((_, index) => (index === btns.length - 1 && btns.length > 1 ? 'danger' : 'default'));

  return (
    <Modal
      width={width}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      centered={centered}
    >
      <div className={clx(styles.modal__content, { [styles.centered]: centered })}>
        {Icon ? <Icon /> : null}
        <div className={styles.title}>{title}</div>
        {content}
        <div className={styles.modal__actions}>
          {btns.map((button, index) => {
            const variantKey = resolvedVariants[index] || 'default';
            const variantClass = styles[BUTTON_VARIANTS[variantKey] || BUTTON_VARIANTS.default];
            return (
              <Button
                key={index}
                onClick={buttonsActions[index] || action}
                className={variantClass}
              >
                {button}
                {showChevron ? ' >' : ''}
              </Button>
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
